module.exports = __webpack_public_path__ + "img/battery_5default.9a23c517.png";